import { AMPLITUDE_OFF_ENROLMENT, } from '@redbubble/next-amplitude';
import { localStorage, sessionStorage } from '@redbubble/persistent-storage';
import React, { createContext, useContext, useEffect, } from 'react';
import { IDENTIFY_THROTTLE_KEY, notifyExposure, useRudderstackClient, } from '../rudderstack';
var AmplitudeExperimentContext = createContext(undefined);
export var AmplitudeExperimentProvider = function (_a) {
    var experiments = _a.experiments, children = _a.children;
    return (React.createElement(AmplitudeExperimentContext.Provider, { value: experiments }, children));
};
function isKnownVariant(value, experimentConfig) {
    return experimentConfig.variants.includes(value);
}
export function useAmplitudeExperiment(experimentConfig) {
    var _a;
    var experiments = useContext(AmplitudeExperimentContext);
    var RudderstackClient = useRudderstackClient().RudderstackClient;
    if (experiments === undefined) {
        throw new Error('AmplitudeExperimentContext used outside of its Provider!');
    }
    var experiment = (_a = experiments[experimentConfig.flagKey]) === null || _a === void 0 ? void 0 : _a.enrolment;
    var knownVariant = experiment && isKnownVariant(experiment, experimentConfig)
        ? experiment
        : false;
    useEffect(function () {
        if (!knownVariant || !RudderstackClient)
            return;
        var flagKey = experimentConfig.flagKey;
        var hasFired = localStorage.getItem(flagKey);
        if (!hasFired) {
            // Written synchronously so the deferred identify below reads an accurate
            // `exposed` trait (localStorage) and an unthrottled state (sessionStorage)
            // when its microtask fires.
            sessionStorage.removeItem(IDENTIFY_THROTTLE_KEY);
            localStorage.setItem(flagKey, knownVariant);
            // (Re-)schedule identify BEFORE queueing the exposure microtask below, so
            // identify()'s microtask is enqueued first and runs first. This covers the
            // late-mount case (a component bearing an experiment that mounts in a later
            // commit than RudderstackIdentifyTracking) as well as the first-load case
            // where identify is already queued from the initial flush.
            notifyExposure();
            // Defer the exposure event to a microtask so it runs AFTER identify(),
            // which establishes the user context (userId) in SDK state — otherwise the
            // exposure event goes out without a userId. Mirrors the page() deferral in
            // useRSPageView; both rely on RudderstackIdentifyTracking rendering before
            // page/experiment components so its identify microtask is queued first.
            queueMicrotask(function () {
                RudderstackClient.exposure({
                    flag_key: flagKey,
                    variant: knownVariant,
                });
            });
        }
    }, [RudderstackClient, knownVariant, experimentConfig.flagKey]);
    return knownVariant || AMPLITUDE_OFF_ENROLMENT;
}
